import {LAB_REPORT } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { ITRFGenerateResponse, ITRFGenerateResponseData } from "@/api_framework/api_modals/LabReport";

AxiosCurlirize(axios, () => {});
export const useTRFGenerateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const [TRFGenerateDetails, setTRFGenerateDetails] = useState<ITRFGenerateResponseData | null>(null);

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (requisition_id: string, action: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: ITRFGenerateResponseData = await axios
          .get(LAB_REPORT?.TRF_GENERATE?.baseURL ?? "", {
            params: {
              requisition_id: requisition_id,
              action: action
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ITRFGenerateResponse>) => {
            if (res.data.status === true && res.data) {
              setTRFGenerateDetails(res.data.data);
              return res.data.data;
            } else {
              setTRFGenerateDetails(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setTRFGenerateDetails(null);
            captureError(e);
            sendCurl(e.config["curlCommand"]);

            return null;
          });
        return response;
      } catch (e: any) {
        setTRFGenerateDetails(null);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, TRFGenerateDetails };
};
